'use client';

import { observer } from 'mobx-react';
import Loading from '../commonUi/Loading/Loading';
import { getStore } from '~/mobx/AppStore';

interface Props {
    isShowed: boolean;
}

const LoadingOverlay = (props: Props) => {
    const { isShowed } = props;

    if (!isShowed) {
        return null;
    }

    return <Loading testId={'loading-overlay'} size={'large'} overlay={true} />;
};

const LoadingOverlayWithStore = () => {
    const { loadingOverlayStore } = getStore();

    return <LoadingOverlay isShowed={loadingOverlayStore.getIsShowed()} />;
};

export default observer(LoadingOverlayWithStore);
